<div class="title_div">
  <div class="w-100 d-flex justify-content-between align-items-center">
    <div class="title_sub_div_1 mt-1">Dashboard</div>
    <div class="title_sub_div_1 title_right_icon_div mr-1">
      <i class="fa fa-refresh" (click)="refreshPage()" title="Refresh dashboard data"></i>
    </div>
  </div>
</div>

<div>
  <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-start">

      <div class="form-group position-relative " title="Project Name" style="width: 150px; ">
        <input id="projectName" class="form-control form-select-lg custom-dropdown-input" type="text"
          placeholder="Search Project Name" [(ngModel)]="selectedProjectName" (input)="filterProjectNames()"
          (focus)="showProjectDropdown = true" (blur)="hideDropdown()" autocomplete="off" />

        <ul class="list-group position-absolute project-dropdown"
          *ngIf="showProjectDropdown && filteredProjectNames.length > 0">
          <li class="list-group-item list-group-item-action project-dropdown-item"
            *ngFor="let name of filteredProjectNames" (mousedown)="selectProjectName(name)" [title]="name">
            {{ name }}
          </li>
        </ul>
      </div>
      <div class="form-group ms-2" title="Customer" style="margin-left: 2px;">

        <select id="customerName" class="form-control form-select-lg" aria-label="Select Customer Name"
          [(ngModel)]="selectedCustomerName" (change)="onSelectCustomer()">
          <option disabled value="" [selected]="selectedCustomerName === ''">Customer </option>
          <option *ngFor="let cus of allCustomerDetails" [value]="cus.customerName">{{ cus.customerName }}</option>
        </select>
      </div>
      <div class="form-group " style="margin-left: 2px;" title="Enginner">
        <select id="enginner" class="form-control form-select-lg" aria-label="Select Enginner Name"
          [(ngModel)]="selectedEngineer" (change)="onSelectEnginner()">
          <option disabled value="" [selected]="selectedEngineer === ''">Engineer </option>
          <option *ngFor="let cus of engineersData" [value]="cus.engineer_id">{{ cus.engineer_name }}</option>
        </select>
      </div>
      <div class="form-group" title="Stage" style="margin-left: 2px;">
        <select id="Stage" class="form-control form-select-lg" aria-label="Select Stage"
          [(ngModel)]="selectedCurrentStage" (change)="onSelectStage($event)">
          <option disabled value="" [selected]="selectedCurrentStage === ''">Select Stage</option>
          <option value="Costing" [selected]="selectedCurrentStage === 'Costing'">Costing</option>
          <option value="Procurement" [selected]="selectedCurrentStage === 'Procurement'">Procurement</option>
        </select>
      </div>

      <!-- Button to trigger the ECD modal -->
      <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
        (click)="openModalECD()">
        ECD Date
      </button>

      <!-- ECD Modal Popup -->
      <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalECD}"
        [ngStyle]="{'display': showModalECD ? 'block' : 'none'}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Expected Completion Date</h5>
              <button type="button" class="close" (click)="closeModalECD()">
                <span aria-hidden="true" style="font-size: 2rem;">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group" title="Expected Completion Date">
                <div style="display: flex; gap: 10px; flex-wrap: wrap;">
                  <div>
                    <label for="fromExpectedCompletionDate">From</label>
                    <input id="fromExpectedCompletionDate" class="custom-date" type="date"
                      aria-label="Select Start Expected Completion Date" [(ngModel)]="fromExpectedCompletionDate"
                      (change)="onSelectCompletionDate()" />
                  </div>
                  <div>
                    <label for="toExpectedCompletionDate">To</label>
                    <input id="toExpectedCompletionDate" class="custom-date" type="date"
                      aria-label="Select End Expected Completion Date" [(ngModel)]="toExpectedCompletionDate"
                      (change)="onSelectCompletionDate()" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <!-- Reset Button -->
              <button type="button" class="btn btn-outline-primary btn-sm form-group"
                (click)="resetDates()">Reset</button>
              <button type="button" class="btn btn-outline-primary btn-sm form-group"
                (click)="closeModalECD()">Close</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Button to trigger the RFQ modal -->
      <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
        (click)="openModalRFQ()">RFQ Date
      </button>

      <!-- RFQ Date Range Modal Popup -->
      <div class="modal" tabindex="-1" role="dialog" [ngClass]="{'show': showModalRFQ}"
        [ngStyle]="{'display': showModalRFQ ? 'block' : 'none'}">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">RFQ Date </h5>
              <button type="button" class="close" (click)="closeModalRFQ()">
                <span aria-hidden="true" style="font-size: 2rem;">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group" title="RFQ Date Range">
                <div style="display: flex; gap: 10px; flex-wrap: wrap;">
                  <div>
                    <label for="fromRfqDate">From</label>
                    <input id="fromRfqDate" class="custom-date" type="date" aria-label="Select From RFQ Date"
                      [(ngModel)]="fromRfqDate" (change)="onDateRangeChange()" />
                  </div>
                  <div>
                    <label for="toRfqDate">To</label>
                    <input id="toRfqDate" class="custom-date" type="date" aria-label="Select To RFQ Date"
                      [(ngModel)]="toRfqDate" (change)="onDateRangeChange()" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <!-- Reset Button -->
              <button type="button" class="btn btn-outline-primary btn-sm form-group"
                (click)="resetRfqDates()">Reset</button>
              <button type="button" class="btn btn-outline-primary btn-sm form-group"
                (click)="closeModalRFQ()">Close</button>
            </div>
          </div>

        </div>

      </div>

      <button type="button" class="btn btn-outline-primary btn-sm form-group" style="background-color: white;"
        title="Reset fields" (click)="resetFields()">Reset</button>
    </div>
    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-outline-primary btn-sm" title="Create New Project"
        (click)="openProjectModel(projectModal, null, null)">Add Project</button>
      <button type="button" class="btn btn-outline-primary btn-sm" title="Create New Customer"
        (click)="openCustomerModel(customerModal)">Add Customer</button>
    </div>
  </div>

  <!-- <div class="d-flex justify-content-between">
    <div class="d-flex justify-content-start">
      <div class="form-group card" (click)="onOpenClickedProject('Open')">
        <div class="custom-card-small custom-card-open-projects">
          <div class="custom-card-content-small">
            <div class="custom-card-number-small">{{openStatusCount}}</div>
            <div class="custom-card-text-small">Open Projects</div>
          </div>
        </div>
      </div>
      <div class="form-group card" (click)="onOverdueClick()">
        <div class="custom-card-small custom-card-overdue">
          <div class="custom-card-content-small">
            <div class="custom-card-number-small">{{overdueCount}}</div>
            <div class="custom-card-text-small">Over Due</div>
          </div>
        </div>
      </div>
      <div class="form-group card" (click)="onThisMonthClick()">
        <div class="custom-card-small custom-card-yet-to-approved">
          <div class="custom-card-content-small">
            <div class="custom-card-number-small">{{ thisMonthProjects?.length || 0 }}</div>
            <div class="custom-card-text-small">This Month</div>
          </div>
        </div>
      </div>
      <div class="form-group card">
        <div class="custom-card-small custom-card-high-risk-parts">
          <div class="custom-card-content-small">
            <div class="custom-card-number-small">10</div>
            <div class="custom-card-text-small">High Risk Parts</div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="d-flex justify-content-start">
    <!-- <div class="form-group card" (click)="onOpenClickedProject('Open')">
    <div class="custom-card-small custom-card-open-projects">
      <div class="custom-card-content-small">
        <div class="custom-card-number-small">{{openStatusCount}}</div>
        <div class="custom-card-text-small">Open Projects</div>
      </div>
    </div>
  </div> -->

    <div class="" (click)="onOpenClickedProject('Open')">
      <div class="custom-card-small custom-card-open-projects" style="padding: 10px;">
        <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">

          <div class="text-block">
            <div class="custom-card-number-small">{{openStatusCount}}</div>
            <div class="custom-card-text-small">Open Projects</div>
          </div>

          <span class="fa fa-folder-open card-icon-right"></span>

        </div>
      </div>
    </div>


    <div (click)="onOverdueClick()">
      <div class="custom-card-small custom-card-overdue" style="padding: 10px;">
        <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">
          <div class="text-block">
            <div class="custom-card-number-small">{{overdueCount}}</div>
            <div class="custom-card-text-small">Over Due</div>
          </div>
          <span class="fa fa-clock card-icon-right"></span>

        </div>
      </div>
    </div>
    <div (click)="onThisMonthClick()">
      <div class="custom-card-small custom-card-yet-to-approved" style="padding: 10px;">
        <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">
          <div class="text-block">
            <div class="custom-card-number-small">{{ thisMonthProjects?.length || 0 }}</div>
            <div class="custom-card-text-small">This Month</div>
          </div>
        </div>
        <span class="fa fa-calendar card-icon-right"></span>
      </div>
    </div>

    <div>
      <div class="custom-card-small custom-card-high-risk-parts" style="padding: 10px;">
        <div class="custom-card-content-small d-flex align-items-center justify-content-between w-100">
          <div class="text-block">
            <div class="custom-card-number-small">10</div>
            <div class="custom-card-text-small">High Risk Parts</div>
          </div>
        </div>
        <span class="fa fa-exclamation-triangle card-icon-right" style="color: black;"></span>
      </div>
    </div>
  </div>

  <div *ngIf="matchedCustomerData.length === 0" class="row row_mar mt-1 w-100">
    <div class="card w-100">
      <div class="card-body ">
        No data found.
      </div>
    </div>
  </div>

  <div *ngIf="matchedCustomerData.length > 0" class="row row_mar mt-1">
    <div class="col-12 grid-margin stretch-card col_pad">
      <div class="card">
        <div class="card-body">

          <!-- Pagination Controls -->
          <div class="pagination-controls">
            <!-- Left: Rows per page -->
            <div>
              <label for="rowsPerPage">Show:</label>
              <select id="rowsPerPage" class="rows-per-page" [(ngModel)]="rowsPerPage" (change)="updateTableRows()">
                <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
              </select>
              rows
            </div>

            <!-- Right: Pagination Navigation with Row Count -->
            <div class="d-flex align-items-center">
              <span class="row-count">
                Showing {{ startIndex }} to {{ endIndex }} of {{ groupedProjectData.length }} rows
              </span>

              <button class="pagination-btn addBtn me-1" (click)="previousPage()"
                [disabled]="currentPage === 1">‹</button>
              <span>Page {{ currentPage }} of {{ totalPages }}</span>
              <button class="pagination-btn addBtn ms-1" (click)="nextPage()"
                [disabled]="currentPage === totalPages">›</button>
            </div>
          </div>
          <div class="table-responsive gd_main_div_mobile">
            <table class="table table-striped custom-hover">
              <thead>
                <tr>
                  <th>Edit</th>
                  <th>S.No</th>
                  <th>Project No</th>
                  <th>Customer Name</th>
                  <th>RFQ Date</th>
                  <th>Assigned To</th>
                  <th>Assigned Date</th>
                  <th>E.C.Date</th>
                  <th class="text-center">Target L.Time(W)</th>
                  <th class="text-center">Ageing</th>
                  <th>Progress</th>
                  <th>Status</th>
                  <th>Current Stage</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let group of paginatedData; let i = index">
                  <td class="editIcon"
                    (click)="openProjectModel(projectModal, group.selectedVersionData, group.project_id)">
                    <i class="fa fa-pencil-alt" aria-hidden="true" title="Edit Row Data"></i>
                  </td>
                  <!-- <td>{{ i+1 }}</td> -->
                  <td>{{ startIndex + i }}</td>

                  <td title="{{ group.projectName }}" (click)="onRowSelect(group)">
                    {{ group.projectName }}
                  </td>
                  <td title="{{ group.selectedVersionData?.customer_name }}" (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.customer_name }}
                  </td>
                  <td class="td_date" title="{{ group.selectedVersionData?.rfqDate | date: 'dd-MM-yyyy' }}"
                    (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.rfqDate | date: 'dd-MM-yyyy' }}
                  </td>
                  <td title="{{ group.selectedVersionData?.assigned_to_name }}" (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.assigned_to_name }}
                  </td>
                  <td class="td_date" title="{{ group.selectedVersionData?.assigned_date | date: 'dd-MM-yyyy' }}"
                    (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.assigned_date | date: 'dd-MM-yyyy' }}
                  </td>
                  <td class="td_date"
                    title="{{ group.selectedVersionData?.expectedCompletionDate | date: 'dd-MM-yyyy' }}"
                    (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.expectedCompletionDate | date: 'dd-MM-yyyy' }}
                  </td>
                  <td class="text-center" title="{{ group.selectedVersionData?.targetLeadTime }}" (click)="onRowSelect(group)">
                    {{ group.selectedVersionData?.targetLeadTime }}
                  </td>

                
                  <td  class="text-center" (click)="onRowSelect(group)"


     [ngStyle]="{'color': (group.selectedVersionData?.status === 'Open' && isECDGreaterThanToday(group.selectedVersionData?.expectedCompletionDate)) ? 'red' : 'inherit'}"
    title="{{ calculateAgeing(group.selectedVersionData?.assigned_date, group.status, group.closed_date) }}">
  
  {{ calculateAgeing(group.selectedVersionData?.assigned_date, group.status, group.closed_date) }}
</td>


                  <td>
                    <div class="progress-container" (click)="onRowSelect(group)">
                      
                      <div
                        style="width: 100%; height: 14px; background-color: #f5f5f5; position: relative; border-radius: 10px; overflow: hidden;">

                        <!-- Progress text -->
                        <div
                          style="position: absolute; z-index: 10; width: 100%; text-align: center; font-size: 12px; color: #000; margin-top: -2px;"
                          *ngIf="group.selectedVersionData?.progress !== undefined && group.selectedVersionData?.progress !== null">
                          {{
                          group.selectedVersionData?.upload_status === 'New'
                          ? '0%'
                          : group.selectedVersionData?.progress
                          }}
                        </div>

                        <!-- Progress bar -->
                        <div [ngStyle]="{
      'width': group.selectedVersionData?.upload_status === 'New'
        ? '0%'
        : group.selectedVersionData?.progress,
      'height': '100%',
      'background-color': '#86c5d8',
      'border-radius': '10px'
    }">
                        </div>

                      </div>



                      <span
                        *ngIf="group.selectedVersionData?.progress === undefined || group.selectedVersionData?.progress === null">
                        No Status
                      </span>
                    </div>
                  </td>
               
                  <td title="{{ group.selectedVersionData?.status }}" (click)="onRowSelect(group)">
                    <span [ngStyle]="{
    'color': group.selectedVersionData?.status === 'Open' ? '#FFA500' : 
              group.selectedVersionData?.status === 'Closed' ? '#e23328' : 'inherit'
  }">
                      {{ group.selectedVersionData?.status }}
                    </span>
                  </td>

                 
                  <td title="{{ group.selectedVersionData?.currentstage }}" (click)="onRowSelect(group)">
                    <span [ngStyle]="{
    'color': group.selectedVersionData?.currentstage === 'Costing' ? '#1e90ff' :
              group.selectedVersionData?.currentstage === 'Procurement' ? '#ff4500' : 'inherit'
  }">
                      {{ group.selectedVersionData?.currentstage }}
                    </span>
                  </td>


                  <td>
                    <select (change)="onVersionChange($event, group)">
                      <option *ngFor="let v of group.versions" [value]="v">{{ v }}</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #customerModal let-modal>
    <form [formGroup]="customerForm">
      <div class="modal-header">
        <h6 class="modal-title">Add Customer</h6>
      </div>
      <div>
        <div class="row">
          <div class="column">
            <label for="_customerFullName">Customer Full Name</label>
            <input type="text" id="_customerFullName" placeholder="Enter Full Name" formControlName="_customerFullName"
              (keyup)="onEnterCustomerName($event)" class="form-control" />
            <small
              *ngIf="customerForm.get('_customerFullName')?.touched && customerForm.get('_customerFullName')?.invalid"
              class="text-danger">
              Full Name is required (min 2 characters)
            </small>
            <div class="error-message" *ngIf="isCustomerNameDuplicate">
              Customer already available, choose a different Customer Name.
            </div>
          </div>
          <div class="column">
            <label for="city">City</label>
            <input type="text" id="city" placeholder="Enter City" formControlName="city" class="form-control" />
            <small *ngIf="customerForm.get('city')?.touched && customerForm.get('city')?.invalid" class="text-danger">
              City is required
            </small>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <label for="state">State</label>
            <input type="text" id="state" placeholder="Enter State" formControlName="state" class="form-control" />
            <small *ngIf="customerForm.get('state')?.touched && customerForm.get('state')?.invalid" class="text-danger">
              State is required
            </small>
          </div>
          <div class="column">
            <label for="country">Country</label>
            <input type="text" id="country" placeholder="Enter Country" formControlName="country"
              class="form-control" />
            <small *ngIf="customerForm.get('country')?.touched && customerForm.get('country')?.invalid"
              class="text-danger">
              Country is required
            </small>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <label for="gstNumber">GST Number</label>
            <input type="text" id="gstNumber" placeholder="Enter GST Number" formControlName="gstNumber"
              class="form-control" />
            <small *ngIf="customerForm.get('gstNumber')?.touched && customerForm.get('gstNumber')?.invalid"
              class="text-danger">
              Enter a valid 15-digit GST Number
            </small>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm" [disabled]="isCustomerNameDuplicate" title="Save"
          (click)="saveCustomer()">Save</button>
        <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
      </div>
    </form>
  </ng-template>


  <ng-template #projectModal let-modal>
  <div class="project-modal-form">
    <form [formGroup]="projectForm">
      <div class="modal-header">
        <h6 class="modal-title">Add/Modify Project</h6>
      </div>
      <div>
        <div class="row">
          <div class="column">
            <label for="newProjectName">Project No</label>
            <input type="text" id="newProjectName" formControlName="newProjectName" (keyup)="enterProject($event)" placeholder="New Project No" />
            <div class="error-message" *ngIf="isProjectNameDuplicate">
              Project already available, choose a different Project No.
            </div>
          </div>
       
        <div class="column customer-column" style="position:relative;">
  <label for="customerFullName">Customer Name</label>
  <div class="d-flex flex-row bd-highlight mb-3" style="align-items:center; position:relative;">
    <i class="fa fa-search customerSearch_icon"></i>
    <ng-select class="mr-2 ng-select-customer"
       [items]="allCustomerDetails" bindLabel="customerName" bindValue="customerName"
       [searchable]="true" (keyup)="onSearch($event)" (change)="onAddNewCustomer($event)"
       formControlName="customerFullName">
    </ng-select>
    <!-- Place the button *after* ng-select, inside the same flex row -->
    <button *ngIf="showAddButton" class="add-customer-btn"
      (click)="openCustomerModel(customerModal)" title="Create new customer"
      type="button">
      <i class="fa fa-plus"></i>
    </button>
  </div>
</div>

        
        </div>
        


   

        <div class="row">
          <div class="column">
            <label for="rfqDate">RFQ Date</label>
            <input type="date" id="rfqDate" formControlName="rfqDate" placeholder="RFQ Date" [max]='maxToday'
              (change)="updateRfqDate()">
          </div>
          <div class="column">
            <label for="completionDate">Expected Completion Date</label>
            <input type="date" id="completionDate" formControlName="completionDate"
              placeholder="Expected Completion Date" [min]="nextMaxDate" [disabled]="isExpectedCompletionDateDisabled"
              (change)="updatecompletionDate()">
          </div>
        </div>

        <div class="row">
          <div class="column">
            <label for="targetLT">Target Lead Time(Weeks)</label>
            <input type="number" formControlName="targetLT" placeholder="Target Lead Time(Weeks)" />
          </div>
          <div class="column">
            <label for="assignTo">Assign To</label>
            <select id="assignTo" name="assignTo" formControlName="assignTo" required>
              <option [ngValue]="null" disabled selected>Select engineer</option>
              <option *ngFor="let user of engineersData" [value]="user.engineer_id">{{ user.engineer_name }}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="column">
            <label for="currentStage">Current Stage</label>
            <select id="currentStage" name="currentStage" class="form-control form-select-lg" aria-label="Select Stage"
              formControlName="currentStage" required>
              <option disabled selected [ngValue]="null">Select Stage</option>
              <option value="Costing">Costing</option>
              <option value="Procurement">Procurement</option>
            </select>
          </div>
          <div class="column">
            <label for="targetLT">Version</label>
            <input type="number" formControlName="version_id" placeholder="Version" />
          </div>
        </div>

        <div class="row">
          <div class="column">
            <label for="city"></label>
            <button type="button" class="btn btn-primary btn-sm ml-1 landing-btn" title="Landing Cost"
              (click)="onLandinCost(landinCostModal)">Landing Cost</button>
          </div>
          <div class="column"></div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-primary btn-sm" [disabled]="isProjectNameDuplicate" (click)="save()" title="Save">Save</button>
        <button type="button" class="btn btn-outline-primary btn-sm" title="Close" (click)="closeModal()">Close</button>
      </div>
    </form>
  </div>
</ng-template>

  <ng-template #landinCostModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title">Landing Cost</h6>
  </div>

  <div class="modal-body">

    <!-- Q1 -->
    <div class="form-group landing_cost_form mb-3">
      <label>Q-1: Do you want to calculate Landing cost for the project?</label>

      <label class="me-3">
        <input type="radio" name="q1"
               [checked]="onQn123?.q1 === true"
               (click)="onQn1Change('yes')">
        Yes
      </label>

      <label>
        <input type="radio" name="q1"
               [checked]="onQn123?.q1 === false"
               (click)="onQn1Change('no', modal)">
        No
      </label>
    </div>

    <!-- Q2 -->
    <div class="form-group landing_cost_form mb-3" *ngIf="showQn2">
      <label>Q-2: Do you want to consider Duties for calculating landing cost?</label>

      <label class="me-3">
        <input type="radio" name="q2"
               [checked]="onQn123?.q2 === true"
               (click)="onQn2Change('yes')">
        Yes
      </label>

      <label>
        <input type="radio" name="q2"
               [checked]="onQn123?.q2 === false"
               (click)="onQn2Change('no', modal)">
        No
      </label>
    </div>

    <!-- Q3 -->
    <div class="form-group landing_cost_form mb-3" *ngIf="showQn3">
      <label>Q-3: Do you want to adjust duty value?</label>

      <label class="me-3">
        <input type="radio" name="q3"
               [checked]="onQn123?.q3 === true"
               (click)="onQn3Change('export')">
        Yes
      </label>

      <label>
        <input type="radio" name="q3"
               [checked]="onQn123?.q3 === false"
               (click)="onQn3Change('no', modal)">
        No
      </label>

      <input *ngIf="showDutyInput"
             type="number"
             class="form-control mt-2"
             placeholder="Enter generic duty percentage"
             [(ngModel)]="dutyValuePercentage"
             style="width: 60%; margin-left: 15px;" />
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary btn-sm"
            title="Save"
            (click)="saveLandingCost(modal)">
      Save
    </button>
    <button type="button" class="btn btn-outline-primary btn-sm"
            title="Close"
            (click)="closeLandingCost(modal)">
      Close
    </button>
  </div>
</ng-template>


</div>

<!-- Transparent Modal with Loading Spinner -->
<div class="modal fade show d-block transparent-modal" *ngIf="isRefresh" id="uploadModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content border-0 bg-transparent text-center">
      <div class="modal-body">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Full-Screen Faded Background -->
<div class="modal-backdrop fade show"></div>